import { render, staticRenderFns } from "./DocumentView.vue?vue&type=template&id=c7c15f46&scoped=true"
import script from "./DocumentView.vue?vue&type=script&lang=js"
export * from "./DocumentView.vue?vue&type=script&lang=js"
import style0 from "./DocumentView.vue?vue&type=style&index=0&id=c7c15f46&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c7c15f46",
  null
  
)

export default component.exports